<template>
    <div class="container-fluid">
        <vue-page-transition name="fade-in-left">
            <router-view/>
        </vue-page-transition>
    </div>
</template>
<script>
export default {
    name: 'financialMovimentView'
}
</script>